let audioContext = null;
let impactAudio = null;
let shootAudio = null;
let hitAudio = null;

export async function loadAudioFiles() {

    try {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const impactRes = await fetch('./hit.mp3');
        const impactBuffer = await impactRes.arrayBuffer();
        impactAudio = await audioContext.decodeAudioData(impactBuffer);
        const shootRes = await fetch('./shot.mp3');
        const shootBuffer = await shootRes.arrayBuffer();
        shootAudio = await audioContext.decodeAudioData(shootBuffer);
        const hitRes = await fetch('./click.mp3');
        const hitBuffer = await hitRes.arrayBuffer();
        hitAudio = await audioContext.decodeAudioData(hitBuffer);
        return audioContext;

    } catch (e) {

        console.warn('Audio files not loaded:', e);
        return new (window.AudioContext || window.webkitAudioContext)();

    }

}



export function playShootSound() {

    if (!audioContext || !shootAudio) return;

    const source = audioContext.createBufferSource();
    source.buffer = shootAudio;
    const gain = audioContext.createGain();
    gain.gain.value = 0.7;
    source.connect(gain);
    gain.connect(audioContext.destination);
    source.start(0);

}



export function playImpactSound() {

    if (!audioContext || !impactAudio) return;

    const source = audioContext.createBufferSource();
    source.buffer = impactAudio;
    const gain = audioContext.createGain();
    gain.gain.value = 0.5;
    source.connect(gain);
    gain.connect(audioContext.destination);
    source.start(0);

}

export function playHitSound() {

    if (!audioContext || !hitAudio) return;

    const source = audioContext.createBufferSource();
    source.buffer = hitAudio;
    const gain = audioContext.createGain();
    gain.gain.value = 0.6;
    source.connect(gain);
    gain.connect(audioContext.destination);
    source.start(0);

}